<template>
  <BaseInput :label="label"
             v-model="formatted_val"
             :text-align="textAlign"
             :read-only-style="readOnlyStyle"
             @keydown="keydown"
             @focusin="focusIn"
             @focusout="focusOut">
    <template v-slot:errors="">
      <slot name="errors"></slot>
    </template>
  </BaseInput>
</template>

<script>
import BaseInput from "@/components/UI/BaseInput/BaseInput";

export default {
  name: "NumberInput",
  components: {BaseInput},
  props: {
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      required: true
    },
    textAlign: {
      type: String,
      default: 'right'
    },
    readOnlyStyle: {
      type: Boolean,
      default: false
    },
    decimals: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      focus: false,
    }
  },
  computed: {
    formatted_val: {
      get() {
        if (!this.focus && this.value !== null) {
          return `${this.getFormattedValue(this.value)}`
        } else {
          return this.value;
        }
      },
      set(value) {
        let val = value;
        //handle comma and replace on dot
        if (val.indexOf(',') > -1) {
          val = val.replace(',', '.')
        }
        //check decimals length
        if (val.indexOf('.') > -1) {
          let parts = val.split('.')
          if (parts[1].length > this.decimals) {
            parts[1] = parts[1].substring(0, this.decimals)
          }
          val = parts.join(".");
        }

        let outside = +val;
        if (val === '' || val === '.' || val === ',') {
          this.$emit('input', null)
        } else {
          this.$emit('input', outside)
        }
      }
    }
  },
  methods: {
    getFormattedValue(x) {
      if (x.toString().indexOf('.') > -1) { //if number got decimals
        let parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        if (parts[1].length > this.decimals) { //check decimals length
          parts[1] = parts[1].substring(0, this.decimals)
        }
        return parts.join(".");
      } else { //just simple formatting w spaces
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      }

    },
    focusIn(e) {
      this.focus = true;
      this.$emit('focusin', e);
    },
    focusOut(e) {
      this.focus = false;
      this.$emit('focusout', e);
    },
    keydown(e) {
      //if decimals is 0
      if ((e.key === ',' || e.key === '.') && this.decimals === 0) {
        e.preventDefault();
      }
      //disable non numeric keys on input to imitate number input
      if (e.key.length === 1 && e.key !== '.' && e.key !== ',' && isNaN(e.key) && !e.ctrlKey && !e.metaKey ||
          ((e.key === ',' || e.key === '.') && (e.target.value.indexOf('.') > -1 || e.target.value.indexOf(',') > -1))
      ) {
        e.preventDefault();
      }
    }
  }
}
</script>